/**
 * G4b/final-fix (Ayrıca notu) — `fmtCarpan` üç dosyada (OzetSerit/SermayeBlok/AkisBlok) birebir
 * kopyaydı; GMROI/devir hızı gibi ORAN ama YÜZDE DEĞİL çarpanlar için (primitives'in `fmtPct`i
 * sondan % basar, bu ise hiç % basmaz). Tek yere alındı.
 */
export function fmtCarpan(n: number, decimals = 2): string {
  return n.toFixed(decimals).replace('.', ',');
}
